import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components/macro';

type TJustifyContent =
  | 'flex-start'
  | 'flex-end'
  | 'center'
  | 'space-between'
  | 'space-around'
  | 'space-evenly'
  | 'initial'
  | 'inherit';

const linkStyle = css<{ $isActive?: boolean }>`
  position: relative;

  svg path {
    stroke: ${({ theme }) => theme.colors.black_60};
  }

  ${({ $isActive }) =>
    !$isActive &&
    css`
    :hover,
    :active {
      svg path {
        stroke: ${({ theme }) => theme.colors.black_70};
      }
      svg rect {
        fill: ${({ theme }) => theme.colors.black_10};
      }
    `}

  
  }

  ${({ $isActive }) =>
    $isActive &&
    css`
      svg path {
        stroke: ${({ theme }) => theme.colors.primary};
      }
      svg rect {
        fill: ${({ theme }) => theme.colors.primary};
      }
    `}

  cursor: pointer;
`;

export const IconWrapper = styled.span<{
  $isActive?: boolean;
  $stroke?: string;
  color?: string;
  margin?: string;
  disabled?: boolean;
  border?: string;
  padding?: string;
  borderRadius?: string;
  fontSize?: string;
  textAlign?: string;
}>`
  ${linkStyle};

  ${({ disabled }) => disabled && `pointer-events: none`};
  ${({ color }) => color && `color: ${color}`};
  ${({ margin }) => margin && `margin: ${margin}`};
  ${({ border }) => border && `border: ${border}`};
  ${({ padding }) => padding && `padding: ${padding}`};
  ${({ borderRadius }) => borderRadius && `border-radius: ${borderRadius}`};
  ${({ textAlign }) => textAlign && `text-align: ${textAlign}`};

  ${({ fontSize }) => fontSize && `font-size: ${fontSize}`};

  ${({ $stroke }) =>
    $stroke &&
    css`
      svg path {
        stroke: ${$stroke};
      }
      svg rect {
        stroke: ${$stroke};
      }
    `}
`;

export const IconWrapperLink = styled(Link)<{ $isActive?: boolean }>`
  ${linkStyle};
`;

export const IconContainer = styled.div<{
  justifyContent?: TJustifyContent;
  margin?: string;
  border?: string;
  borderRadius?: string;
  padding?: string;
}>`
  display: flex;
  ${({ justifyContent }) => justifyContent && ` justify-content: ${justifyContent}; `}
  ${({ margin }) => margin && `margin: ${margin}`};
  ${({ border }) => border && `border: ${border}`};
  ${({ borderRadius }) => borderRadius && `border-radius: ${borderRadius}`};
  ${({ padding }) => padding && `padding: ${padding}`};
`;
